import {useEffect} from "react";
import {get} from "lodash";
import NiceModal from "@ebay/nice-modal-react";
import {useLocation, useNavigate} from "react-router-dom";
import {campaignMap} from "~/pages/account/account/components/campaigns/utils";

export const useCampaignDialog = (accountId?: string) => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const campaignName = location.state?.campaign;
    if (!campaignName || !accountId) return;

    const CampaignComponent = get(campaignMap, campaignName);
    if (!CampaignComponent) return;

    const clearCampaignFromState = () => {
      navigate(
        {pathname: location.pathname, search: location.search, hash: location.hash},
        {replace: true, state: {...location.state, campaign: undefined}}
      );
    };

    NiceModal.show(CampaignComponent, {clearCampaignFromState, accountId});
  }, [accountId]);
};
